import React from "react";
import { useDispatch } from "react-redux";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import { COLORS } from "@gc-npm/utils.enums.colors";
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT
} from "@gc-npm/components.text";
import CustomLink from "@gc-npm/components.custom-link";
import Button, { BUTTON_WIDTH } from "@gc-npm/components.button";
import Price, {
  PRICE_FONT_WEIGHT,
  PRICE_SIZE,
  PRICE_DECORATION,
} from "@gc-npm/components.price";

const ShoppingCartFooterModalFichaDesktop = (props) => {
  const {
    price,
    quotePromo,
    isConexion,
    buttonText,
    onClick,
    selected,
    taggingInfo,
    finalPromoPrice,
    promoDuration,
    promoPriceAlt,
    stateProps,
  } = props;

  const dispatch = useDispatch();
  const { isLoading } = stateProps;
  const onclickHandler = () => {
    onClickClose();
    onClick(false, true);
  };
  const onClickClose = () => {
    if (!isLoading) {
      dispatch(modalActions.addModal({ id: "" }));
    }
  };
  const hasPromoPrice =
    finalPromoPrice !== null &&
    finalPromoPrice !== undefined &&
    !isNaN(finalPromoPrice);
  const promoPrice = hasPromoPrice ? finalPromoPrice : null;
  return (
    <div className="ShoppingCartFooterModalFichaDesktop shoppingCartBoxShadow ">
      <CustomLink
        taggingInfo={{ ...taggingInfo, componentContent: "Desplegar" }}
        onClick={onClickClose}
        className="shoppingCartFooterButton"
      >
        <span className="accessibleAction">Cerrar información: </span>
        <div className="info">
          <div className="priceSection">
            <div className="prices">
              <div className="footerPrice">
                <div className="footerPriceWrapper">
                  <Price
                    price={price}
                    color={
                      hasPromoPrice ? TEXT_COLOR.GREY4 : TEXT_COLOR.GREY6
                    }
                    decoration={
                      hasPromoPrice ? PRICE_DECORATION.LINE_THROUGH : undefined
                    }
                    currency="€"
                    quote="mes"
                    fontType={
                      hasPromoPrice
                        ? PRICE_FONT_WEIGHT.REGULAR
                        : PRICE_FONT_WEIGHT.BOLD
                    }
                    fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                    size={PRICE_SIZE.XS}
                  />
                  <Price
                    {...promoPriceAlt}
                    price={promoPrice}
                    color={TEXT_COLOR.RED_DARK}
                    currency="€"
                    fontType={PRICE_FONT_WEIGHT.BOLD}
                    fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                    quote={quotePromo}
                    size={PRICE_SIZE.XS}
                  />
                </div>
                <div className="promo">
                  <TextInfo
                    text={promoDuration}
                    color={TEXT_COLOR.RED_DARK}
                    fontType={TEXT_FONT_WEIGHT.REGULAR}
                    size={TEXT_SIZE.CAPTION}
                    align="right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </CustomLink>
      {!(isConexion && selected) && (
        <div className="buttons">
          <Button
            label={buttonText}
            onClick={onclickHandler}
            taggingInfo={{...taggingInfo, componentName: "shoppingcartinfoModal",componentContent:buttonText,  }}
            width={BUTTON_WIDTH.MEDIUM}
            disabled={isLoading}
          />
        </div>
      )}
      <style jsx>
        {`
          .accessibleAction {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip-path: inset(50%);
            white-space: nowrap;
          }
          .ShoppingCartFooterModalFichaDesktop {
            position: static !important;
            z-index: 30;
            bottom: 0px;
            left: 0px;
            width: 100%;
            background-color: ${COLORS.grey100};
            border-top: 2px solid ${COLORS.grey200};
            padding: 0.75rem 1.5rem;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            min-height: 74px;
            gap: 8px;
            &.shoppingCartBoxShadow {
              box-shadow: 0px -2px 8px #00000029;
            }
            :global(.info) {
              display: flex;
              flex-direction: row;
              -webkit-box-pack: justify;
              justify-content: space-between;
              -webkit-box-align: center;
              align-items: center;
              gap: 0.5rem;
              padding-right: 0.5rem;
              min-width: max-content;
            }
            .prices {
              display: flex;
              flex-direction: row;
              gap: 1rem;
              .footerPrice {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                .footerPriceWrapper {
                  display: flex;
                  gap: 1rem;
                  flex-direction: row;
                }
              }
              .spinnnerWrapper {
                padding-right: 1rem;
                width: 100%;
                display: flex;
                position: relative;
                flex-direction: row;
                justify-content: center;
                align-items: center;
              }
            }
            .buttons {
              display: flex;
              -webkit-box-pack: justify;
              justify-content: flex-end;
              flex-flow: row;
              gap: 0.5rem;
              align-items: center;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ShoppingCartFooterModalFichaDesktop;
